import { z } from "zod";
import { extendZodWithOpenApi } from "zod-openapi";
import { errorResponse, formBody, successResponse, tagPaths } from "../util.ts";
import { created_at, simpleSuccessResponse, user_id, uuid } from "./common.ts";
import * as params from "./params.ts";

extendZodWithOpenApi(z);

//#region SSH Keys
export const SshKeyUpdateBody = z
    .object({
        name: z.string().describe("A human-friendly name for the key, unique per user"),
    })
    .openapi({ ref: "SshKeyUpdateBody" });

export const SshKeyCreateBody = SshKeyUpdateBody.extend({
    public_key: z.string().describe("Full OpenSSH public key line; no strict format validation is performed"),
}).openapi({ ref: "SshKeyCreateBody" });

export const SshKey = SshKeyCreateBody.extend({
    created_at,
    user_id,
    uuid,
}).openapi({ ref: "SshKey" });
//#endregion

export const SshKeyResponse = z.array(SshKey);

export const sshKeysPaths = tagPaths("ssh_keys")({
    "/user-resource/ssh_keys": {
        get: {
            summary: "List SSH keys",
            description: "List all SSH public keys associated with the authenticated user.",
            responses: {
                ...successResponse(SshKeyResponse),
                ...errorResponse(`Failed to list ssh keys`),
            },
        },
        post: {
            summary: "Create SSH key",
            description: "Create a new SSH public key. The public_key is immutable once created.",
            requestBody: formBody(SshKeyCreateBody),
            responses: {
                ...successResponse(SshKey),
            },
        },
    },
    "/user-resource/ssh_keys/{uuid}": {
        patch: {
            summary: "Update SSH key name",
            description: "Rename an existing SSH key. Only metadata (name) can be changed.",
            parameters: [params.uuid],
            requestBody: formBody(SshKeyUpdateBody),
            responses: {
                ...successResponse(SshKey),
            },
        },
        delete: {
            summary: "Delete SSH Key",
            description: "Delete an SSH key by UUID.",
            parameters: [params.uuid],
            responses: {
                ...simpleSuccessResponse,
            },
        },
    },
});
